"use client";

import React, { useEffect, useState } from "react";
import { m as motion, useScroll, useSpring } from "framer-motion";

export const ReadingProgress: React.FC = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] h-1.5 pointer-events-none">
      <motion.div
        className="h-full bg-primary origin-left relative shadow-[0_0_10px_rgba(var(--primary-rgb),0.5)]"
        style={{
          scaleX,
          opacity: visible ? 1 : 0,
        }}
      >
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-r from-transparent to-white/40 blur-sm" />
      </motion.div>
    </div>
  );
};

export default ReadingProgress;
